<template>
    <div>
        <el-upload ref="upload" :headers="{token: $store.state.app.token}" :action="action"
                   :before-upload="beforeUpload"
                   :on-success="uploadSuccess"
                   :on-remove="uploadRemove"
                   :on-progress="uploadProgress"
                   :on-error="uploadError"
                   :data="data"
                   :show-file-list="this.showFileList"
                   :accept="accept"
                   :file-list="fileList"
                   :class="getUploadMode">
            <template v-if="$slots.default">
                <slot></slot>
            </template>
            <template v-else>
                <el-button type="primary">文件上传</el-button>
            </template>
            <div slot="tip" style="padding-top:5px;">
                <slot name="tip">支持doc、docx、xls、xlsx、ppt、pptx、pdf、jpg、jpeg、gif、psd、png、swf、avi、htm、html等格式，建议大小不超过20MB
                </slot>
            </div>
        </el-upload>
    </div>
</template>
<script type="text/javascript">
    import axios from 'axios'

    function noop () {}

    export default {
        props: {
            action: {
                type: String,
                'default': '/hr/attach/fileInsert.api'
            },
            value: Array,
            onProgress: {
                type: Function,
                'default': noop
            },
            onSuccess: {
                type: Function,
                'default': noop
            },
            onRemove: {
                type: Function,
                'default': noop
            },
            onFail: {
                type: Function,
                'default': noop
            },
            showFileList: {
                type: Boolean,
                'default': true
            },
            showFailMsg: {
                type: Boolean,
                'default': true
            },
            showLoading: {
                type: Boolean,
                default: false
            },
            uploadMode: {
                type: String,
                default: 'default'
            },
            accept: {
                type: String,
                default: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.jpeg,.gif,.psd,.png,.swf,.avi,.htm,.html'
            },
            data: Object,
            fileList: {
                type: Array,
                'default': function () {
                    return []
                }
            },
            fileLimit: {
                type: Number,
                'default': 5  // 默认限制5个，小于或者等于0为不限
            }
        },
        data () {
            return {
                uploadedData: this.value || []
            }
        },
        computed: {
            getUploadMode () {
                return `upload-${this.uploadMode}-mode`
            }
        },
        watch: {
            value (newValue) {
                this.uploadedData = newValue
            }
        },
        methods: {
            beforeUpload (file) {
                const isLt20M = file.size / 1024 / 1024 < 20
                if (this.fileLimit > 0 && this.fileLimit === this.uploadedData.length) {
                    this.$message.error(`上传文件个数不能超过${this.fileLimit}`)
                    return false
                }
                if (!isLt20M) {
                    this.$message.error('上传文件大小不能超过20MB！')
                    return false
                }
                this.uploadedData.push({
                    fileName: file.name,
                    fileSize: file.size,
                    fileUid: file.uid
                })
                this.showLoading && this.$store.dispatch('LOADING', true)
            },
            uploadProgress (event, file, fileList) {
                this.onProgress(event, file, fileList)
            },
            uploadSuccess (res, file) {
                this.showLoading && this.$store.dispatch('LOADING', false)
                if (res.status === true || res.status === 'true') {
                    let uploadedItem = {
                        id: res.result.id,
                        md5: res.result.md5,
                        fileId: res.result.fileId,
                        fileName: file.name,
                        fileSize: file.size,
                        fileStatus: file.status,
                        fileUid: file.uid
                    }
                    this.uploadedData.forEach((item, index) => {
                        if (item.fileUid === uploadedItem.fileUid) {
                            this.uploadedData.splice(index, 1, uploadedItem)
                        }
                    })
                    this.$emit('input', this.uploadedData)
                    this.onSuccess(res, file)
                } else {
                    this.$refs.upload.handleRemove(file)
                    this.onFail(res)
                    this.showFailMsg && this.$message({
                        message: res.desc,
                        type: 'error'
                    })
                }
            },
            uploadRemove (file, fileList) {
                if (!file) {
                    return
                }
                this.uploadedData.forEach((item, index) => {
                    if (item.fileUid === file.uid) {
                        this.uploadedData.splice(index, 1)
                    }
                })
                this.$emit('input', this.uploadedData)
                this.onRemove(file, fileList)
            },
            uploadError (err, file, fileList) {
                console.log('upload error', err)
                this.uploadedData.forEach((item, index) => {
                    if (item.fileUid === file.uid) {
                        this.uploadedData.splice(index, 1)
                    }
                })
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    .upload-silence-mode {
        .el-upload-list {
            display : none !important;
        }
    }
</style>



// WEBPACK FOOTER //
// fileUpload.vue?0d78420a